<ng-container style="margin-left: 5px;" *ngIf="!showNewConfig; else newconfig">
    <div fxLayout="row" style="margin-left: 5px;">
      <ng-container *ngIf="configattributeType==1;">
        <div [style.padding-top]="configurationDropDownList.size==0 ? '0px' : '10px'" fxLayout="row"
          *ngFor="let item of configurationDropDownList | keyvalue">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>
              {{item.key.replace('_', ' ') }}
            </mat-label>
            <mat-select (selectionChange)="getConfigProductId($event.value,i)"
             [disableOptionCentering]="true"
              [formControl]="dropDownValue">
              <mat-option [value]="object" *ngFor="let object of item.value;let i=index ">
                {{object |splitbyHash}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>


      <ng-container *ngIf="configattributeType==2;">

        <span class="mtb10">

          <div class="size mtb10" fxLayoutGap="5px" fxLayout="column"
            *ngFor="let item of configurationDropDownList | keyvalue">
            <div fxFlex fxLayout="row">
              <span> {{item.key.replace('_', ' ') }}:</span>
            </div>

            <div fxFlex fxLayout="row">
              <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                <div fxFlex="18" *ngFor="let object of item.value;let i=index;" class="imagesProduct"
                  [class.highlightedImage]="firstIndex ==i" [class.highlightedImage1]="firstIndex !=i"
                  fxLayout="column" fxLayoutAlign="center center">
                  <div class="imagesPro padding-3">
                    <a (click)="getConfigProductId(object,i)">
                      <img [alt]="name" class="imgH" [src]="getImageproductIdOld(object)"
                        onerror="this.src='assets/images/products/noImage/no-image.png';">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>



      </ng-container>

      <ng-container *ngIf="configattributeType==4;">
        <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">

          <div class="size,mtb10" fxLayoutGap="5px">
            <span class="fw-500"> {{item.key.replace('_', ' ') }}:</span>
            <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px" mat-raised-button
              (click)="getConfigProductId(object,i)" *ngFor="let object of item.value;let i=index;"
              [style.background]="object |splitbyHash">&nbsp;</button>
          </div>
        </span>

      </ng-container>

      <ng-container *ngIf="configattributeType==3;">
        <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">

          <div class="size mtb10" fxLayoutGap="5px">
            <span class="fw-500 mtb10"> {{item.key.replace('_', ' ') }}:&nbsp;</span>
            <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px" mat-raised-button
              (click)="getConfigProductId(object,i)" *ngFor="let object of item.value;let i=index;">
              {{object |splitbyHash}}
            </button>
          </div>
        </span>

      </ng-container>

    </div>
  </ng-container>


  <ng-template #newconfig>
    <div fxLayout="row" style="margin-left: 5px;" fxLayoutGap="5px">
      <ng-container>

        <ng-container *ngIf="configurationDropDownList[0].configAttributeType==1;
       ">


          <mat-form-field appearance="outline" fxFlex>
            <mat-label>
              {{configurationDropDownList[0].key}}
            </mat-label>


            <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
              <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')"
                [value]="item.value" *ngFor="let item of configurationDropDownList;let i=index;">
                {{item.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </ng-container>


        <ng-container *ngIf="configurationDropDownList[0].configAttributeType==4;">

          <span class="mtb10">

            <div class="size,mtb10" fxLayoutGap="5px">
              <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
              <button [class.highlightedImage]="i == firstIndex" fxLayoutGap="5px" mat-raised-button
                (click)="getConfigProductIdButton(i,'firstIndex')"
                *ngFor="let size of configurationDropDownList;let i=index;"
                [style.background]="size.value">&nbsp;</button>
            </div>
          </span>

        </ng-container>

        <ng-container *ngIf="configurationDropDownList[0].configAttributeType==5;">

          <span class="mtb10">

            <div class="size,mtb10" fxLayoutGap="5px">
              <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
              <button fxLayoutGap="5px" mat-mini-fab (click)="getConfigProductIdButton(i,'firstIndex')"
                *ngFor="let size of configurationDropDownList;let i=index;" [style.background]="size.value">
                <mat-icon *ngIf="i == firstIndex">done</mat-icon>
              </button>
            </div>
          </span>

        </ng-container>

        <ng-container *ngIf="configurationDropDownList[0].configAttributeType==2;">
          <span class="mtb10">

            <div class="size,mtb10" fxLayoutGap="5px">
              <span>{{configurationDropDownList[0].key}}:</span>
              <div fxFlex fxLayout="row">
                <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                  <div fxflex="33.33" *ngFor="let size of configurationDropDownList;let i=index;"
                    class="imagesProduct" [class.highlightedImage]="i == firstIndex" fxLayout="column"
                    fxLayoutAlign="center center">
                    <div class="imagesPro padding-3">
                      <a (click)="getConfigProductIdButton(i,'firstIndex')">


                        <img [alt]="name" class="imgH" [src]="getImageproductId(size.productId)"
                          onerror="this.src='assets/images/products/noImage/no-image.png';" alt="">
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </span>

        </ng-container>



        <ng-container *ngIf="configurationDropDownList[0].configAttributeType==3;">
          <span class="mtb10">

            <div class="size,mtb10" fxLayoutGap="5px">
              <span>{{configurationDropDownList[0].key}}:</span>

              <button fxLayoutGap="5px" mat-raised-button (click)="getConfigProductIdButton(i,'firstIndex')"
                [class.highlightedImage]="firstIndex ==i "
                *ngFor="let size of configurationDropDownList;let i=index;">

                {{size.value}}</button>
            </div>
          </span>

        </ng-container>


      </ng-container>
    </div>
    <div fxLayout="row" style="margin-left: 5px;">
      <ng-container fxLayout="row">
        <ng-container *ngIf="configurationDropDownList[0]
      ['recursuive'][0].configAttributeType==1;">

          <mat-form-field appearance="outline" fxFlex>
            <mat-label>
              {{configurationDropDownList[0]
              ['recursuive'][0].key}}
            </mat-label>
            <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
        .recursuive[secondIndex].value" [disableOptionCentering]="true">
              <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
 ['recursuive'];let j=index;">
                {{item1.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>


        <ng-container *ngIf="configurationDropDownList[0]
     ['recursuive'][0].configAttributeType==2;">
          <span class="mtb10">

            <div class="size,mtb10" fxLayoutGap="5px">
              <span>{{configurationDropDownList[0]
                ['recursuive'][0].key}}:</span>
              <div fxFlex fxLayout="row">
                <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                  <div fxflex="33.33" *ngFor="let size of  configurationDropDownList[firstIndex]
                ['recursuive'];let j=index;" class="imagesProduct" [class.highlightedImage]="secondIndex ==j"
                    fxLayout="column" fxLayoutAlign="center center">
                    <div class="imagesPro padding-3">

                      <a (click)="getConfigProductIdButton(j,'secondIndex')">

                        <img [alt]="name" class="imgH" [src]="getImageproductId(size.productId)"
                          onerror="this.src='assets/images/products/noImage/no-image.png';" >
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </span>

        </ng-container>

        <ng-container *ngIf="configurationDropDownList[0]
    ['recursuive'][0].configAttributeType==4;">

          <span class="mtb10">

            <div class="size,mtb10" fxLayoutGap="5px">
              <span class="fw-500"> {{configurationDropDownList[0]
                ['recursuive'][0].key}}:</span>
              <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px" mat-raised-button
                (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
        ['recursuive'];let j=index; " [style.background]="size.value">&nbsp;</button>
            </div>
          </span>

        </ng-container>

        <ng-container *ngIf="configurationDropDownList[0]
    ['recursuive'][0].configAttributeType==5;">

          <span class="mtb10">

            <div fxLayoutGap="5px">
              <span> {{configurationDropDownList[0]
                ['recursuive'][0].key}}:</span>
              <button [class.highlightedImage]="secondIndex ==j" mat-mini-fab
                (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
        ['recursuive'];let j=index; " [style.background]="size.value">
                &nbsp;</button>
            </div>
          </span>

        </ng-container>



        <ng-container *ngIf="configurationDropDownList[0]
    ['recursuive'][0].configAttributeType==3;">
          <span class="mtb10">

            <div class="size,mtb10" fxLayoutGap="5px">
              <span class="fw-500"> {{configurationDropDownList[0]
                ['recursuive'][0].key}}:</span>
              <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px" mat-raised-button
                (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
        ['recursuive'];let j=index;">{{size.value}}</button>
            </div>
          </span>

        </ng-container>
      </ng-container>
    </div>

  </ng-template>